import Vue from 'vue'
import Router from 'vue-router'

import AdminRouter from './admin-router'
import DriverRouter from './driver-router'
import DriverAppRouter from './driver-app-router'
import EdiRequestRouter from './edi-request-router'
import NotFoundError from '../errors/404'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {...AdminRouter},
    {...DriverRouter},
    {...DriverAppRouter},
    {...EdiRequestRouter},
    {
      path: '*',
      name: 'NotFoundError',
      component: NotFoundError,
    },
    {
      path: '/',
      redirect: '/driver',
    },
  ],
  
  /**
   * 画面遷移後のスクロール制御
   * @param to
   * @param from
   * @param savedPosition
   * @return {Position|{x: number, y: number}}
   */
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
